import type { PlainAuthenticationMethodPersonalAccessToken, PlainRunner } from "@/queries/runner-queries";
import { Code, ConnectError } from "@connectrpc/connect";

export type CreateEnvironmentStage =
    | { type: "input" }
    | {
          type: "scm-authentication";
          authenticationUrl: string;
          patAuth?: PlainAuthenticationMethodPersonalAccessToken;
          scmId: string;
          scmName: string;
          runner: PlainRunner;
          contextUrl: string;
          onClickContinue?: () => void;
      };

export const TabsValues = {
    project: "project",
    url: "url",
    scratch: "scratch",
} as const;
export type TabValue = (typeof TabsValues)[keyof typeof TabsValues];

export const isNoSuitableRunnerFoundError = (error: unknown) => {
    return (
        error instanceof ConnectError &&
        error.code === Code.NotFound &&
        error.message.includes("no suitable runner found")
    );
};
